export function loadCartIcon() {
    // Find ALL cart icon elements with data-icon-label (desktop, mobile, etc.)
    const cartIconLabels = document.querySelectorAll('[data-icon-label]');
    
    if (!cartIconLabels || cartIconLabels.length === 0) {
        console.log('Cart icon label elements not found');
        return;
    }
    
    // Find the sessionStorage key that starts with 'wc_fragments'
    let wcFragmentsKey = null;
    for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith('wc_fragments')) {
            wcFragmentsKey = key;
            break;
        }
    }
    
    if (!wcFragmentsKey) {
        console.log('WooCommerce fragments not found in sessionStorage');
        return;
    }
    
    try {
        // Get and parse the fragments data
        const fragmentsData = JSON.parse(sessionStorage.getItem(wcFragmentsKey));
        const cartHtml = fragmentsData['div.widget_shopping_cart_content'];
        
        if (!cartHtml) {
            console.log('Cart content not found in fragments');
            return;
        }
        
        // Create a temporary DOM element to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = cartHtml;
        
        // Sum up all quantities from cart items
        let totalQuantity = 0;
        const allQuantityInputs = tempDiv.querySelectorAll('input.qty, input[type="number"], input[name^="cart["]');
        
        allQuantityInputs.forEach(input => {
            const qty = parseInt(input.value, 10);
            if (!isNaN(qty)) {
                totalQuantity += qty;
            }
        });
        
        // Update all cart icon labels (desktop, mobile, etc.)
        cartIconLabels.forEach(cartIconLabel => {
            cartIconLabel.setAttribute('data-icon-label', totalQuantity);
        });
                
    } catch (error) {
        console.error('Error parsing WooCommerce fragments:', error);
    }
}